export function normalizeOib (raw) {
  if (!raw) return ''
  return String(raw)
    .replace(/\s+/g, '')
    .replace(/^\d+:/, '')
    .replace(/^HR/i, '')
}

export function findSuppliersByOib (associates, rawOib) {
  const target = normalizeOib(rawOib)
  if (!target) return []
  return associates.filter(associate => {
    const candidates = [associate.oib, ...(associate.oibs || [])]
    return candidates.some(oib => normalizeOib(oib) === target)
  })
}
